var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03168 13C11.0694 13 14.3719 7.99814 14.3719 3.66053C14.3719 3.51846 14.3718 3.37702 14.3622 3.23623C15.0047 2.77157 15.5593 2.19623 16 1.53715C15.4009 1.80261 14.7654 1.9767 14.1146 2.05361C14.7999 1.64338 15.3127 0.998163 15.5577 0.238044C14.9133 0.620388 14.2084 0.889844 13.4733 1.03479C12.4557 -0.0471239 10.8389 -0.311925 9.52934 0.388867C8.21979 1.08966 7.54325 2.58177 7.87908 4.0285C5.23965 3.89619 2.78049 2.6496 1.11363 0.598979C0.242347 2.0988 0.687381 4.01754 2.12995 4.98076C1.60754 4.96528 1.09652 4.82436 0.640017 4.5699C0.640017 4.58334 0.640017 4.59741 0.640017 4.61149C0.640444 6.174 1.74193 7.51979 3.27361 7.82918C2.79033 7.96097 2.28321 7.98024 1.79132 7.88549C2.22137 9.22263 3.45381 10.1386 4.85825 10.165C3.69584 11.0785 2.25986 11.5744 0.781424 11.5729C0.520243 11.5724 0.259332 11.5566 0 11.5255C1.50121 12.4889 3.24795 12.9998 5.03168 12.9975"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 13
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b3abbdef.svg";
export { ForwardRef as ReactComponent };